
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class PhotoCarouselViewer extends Vue {
  @Prop({ type: Array, required: true }) photos!: any[];
  @Prop({ type: Function, required: true }) photoPath!: (photo: any) => string;
  @Prop({ type: Function }) formatDate?: (date: any) => string;
  @Prop({ type: Boolean, default: true }) showMetadata!: boolean;
  @Prop({ type: [String, Number], default: 520 }) carouselHeight!: string | number;

  currentIndex = 0;
  hoveredIndex = -1;
  zoomDialog = false;
  zoomedPhoto: any = null;
  zoomLevel = 1;
  isPanning = false;
  panStart = { x: 0, y: 0 };
  imageNaturalWidth = 0;
  imageNaturalHeight = 0;
  zoomViewportWidth = 0;
  zoomViewportHeight = 0;
  handleResize = () => this.updateZoomViewport();

  get fittedImageSize() {
    if (!this.imageNaturalWidth || !this.imageNaturalHeight || !this.zoomViewportWidth || !this.zoomViewportHeight) {
      return { width: 0, height: 0 };
    }

    const fitScale = Math.min(
      this.zoomViewportWidth / this.imageNaturalWidth,
      this.zoomViewportHeight / this.imageNaturalHeight,
      1,
    );

    return {
      width: this.imageNaturalWidth * fitScale,
      height: this.imageNaturalHeight * fitScale,
    };
  }

  get zoomedImageStyle() {
    return {
      width: `${this.fittedImageSize.width * this.zoomLevel}px`,
      height: `${this.fittedImageSize.height * this.zoomLevel}px`,
    };
  }

  get zoomImageStageStyle() {
    return {
      width: `${Math.max(this.zoomViewportWidth, this.fittedImageSize.width * this.zoomLevel)}px`,
      height: `${Math.max(this.zoomViewportHeight, this.fittedImageSize.height * this.zoomLevel)}px`,
    };
  }

  openZoom(photo: any) {
    this.zoomedPhoto = photo;
    this.zoomLevel = 1;
    this.zoomDialog = true;
    this.$nextTick(() => this.updateZoomViewport());
  }

  closeZoom() {
    this.zoomDialog = false;
    this.zoomedPhoto = null;
  }

  onZoomImageLoad(event: Event) {
    const image = event.target as HTMLImageElement;
    this.imageNaturalWidth = image.naturalWidth;
    this.imageNaturalHeight = image.naturalHeight;
    this.updateZoomViewport();
  }

  updateZoomViewport() {
    const zoomContent = this.$refs.zoomContent as HTMLElement | undefined;
    if (!zoomContent) {
      return;
    }

    this.zoomViewportWidth = zoomContent.clientWidth;
    this.zoomViewportHeight = zoomContent.clientHeight;
  }

  zoomIn() {
    this.zoomLevel = Math.min(3, this.zoomLevel + 0.25);
  }

  zoomOut() {
    this.zoomLevel = Math.max(0.5, this.zoomLevel - 0.25);
  }

  onZoomWheel(e: WheelEvent) {
    if (e.deltaY < 0) {
      this.zoomIn();
    } else {
      this.zoomOut();
    }
  }

  startPan(e: MouseEvent) {
    e.preventDefault();
    this.isPanning = true;
    this.panStart = { x: e.clientX, y: e.clientY };
  }

  onPan() {
    // Pan could be implemented with transform translate
  }

  endPan() {
    this.isPanning = false;
  }

  mounted() {
    window.addEventListener('resize', this.handleResize);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }

  formatDateDisplay(date: any): string {
    if (this.formatDate) {
      return this.formatDate(date);
    }
    return date ? new Date(date).toLocaleString() : '';
  }
}
